
import { computed, defineComponent, PropType, reactive, ref } from 'vue'

// UI
import TheTime from '@/common/components/UI/TheTime/index.vue'
import TheButton from '@/common/components/UI/TheButton/index.vue'
import TheSelect from '@/common/components/UI/TheSelect/index.vue'

// types

// constants
import { WORK_WEEK_DAYS } from '@/core/constants/companies.constants'
import { COURIER_DEFAULT_GRAPH } from '@/core/constants/couriers.constants'
import { CourierWorkDay } from '@/core/types/couriers.types'

export default defineComponent({
    components: {
        TheTime,
        TheButton,
        TheSelect,
    },
    emits: ['add', 'remove'],
    props: {
        schedules: {
            type: Array as PropType<CourierWorkDay[]>,
            default: () => [],
        },
    },
    setup(props, { emit }) {
        const add_state = reactive({
            weekday: null as string | null,
        })

        const onRemoveSchedule = (weekday: number) => {
            emit('remove', weekday)
        }

        const onAddWeekday = () => {
            if (add_state.weekday === null) return

            emit('add', add_state.weekday)
            add_state.weekday = null
        }

        const weekDaysForSelect = computed(() => {
            const weekdays = WORK_WEEK_DAYS.map((day, index) => {
                return {
                    id: index.toString(),
                    name: day,
                }
            }).filter(
                (day) => !props.schedules.some((schedule) => schedule.weekday === Number(day.id))
            )

            return weekdays
        })

        return {
            add_state,
            //
            weekDaysForSelect,
            onAddWeekday,
            onRemoveSchedule,
            //
            WORK_WEEK_DAYS,
            COURIER_DEFAULT_GRAPH,
        }
    },
})
